<section class="playground">
  <h2 class="playground__heading">Toggle panel</h2>
  <p class="playground__hint">
    <code>common-toggle-panel</code> — panel con toggle y etiquetas de estado activo/inactivo.
    Figma componentSet <code>247:31285</code>.
  </p>

  <div class="playground__grid">
    <div class="playground__controls">
      <label class="playground__field">
        <span>activeLabel</span>
        <input type="text" [(ngModel)]="activeLabel" />
      </label>

      <label class="playground__field">
        <span>inactiveLabel</span>
        <input type="text" [(ngModel)]="inactiveLabel" />
      </label>

      <label class="playground__field playground__field--checkbox">
        <input type="checkbox" [(ngModel)]="checked" />
        <span>checked (valor inicial)</span>
      </label>

      <label class="playground__field playground__field--checkbox">
        <input type="checkbox" [(ngModel)]="disabled" />
        <span>disabled</span>
      </label>

      <label class="playground__field playground__field--checkbox">
        <input type="checkbox" [(ngModel)]="showPanelBorder" />
        <span>bordered (borde visible; si off, hover con sombra)</span>
      </label>
    </div>

    <div class="playground__preview">
      <p class="playground__preview-title">Preview</p>
      <div class="playground__preview-box">
        <common-toggle-panel
          [activeLabel]="activeLabel"
          [inactiveLabel]="inactiveLabel"
          [checked]="checked"
          [disabled]="disabled"
          [bordered]="showPanelBorder"
          (change)="onChange($event)"
        ></common-toggle-panel>
      </div>

      <p *ngIf="lastEvent" class="playground__meta">{{ lastEvent }}</p>
    </div>
  </div>
</section>
